import { render, staticRenderFns } from "./screen-topbar.vue?vue&type=template&id=6a5f7f53&scoped=true"
import script from "./screen-topbar.vue?vue&type=script&lang=ts"
export * from "./screen-topbar.vue?vue&type=script&lang=ts"
import style0 from "./screen-topbar.vue?vue&type=style&index=0&id=6a5f7f53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5f7f53",
  null
  
)

export default component.exports